var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableContainer = void 0;
var TableContainer_1 = __importDefault(require("./TableContainer"));
exports.TableContainer = TableContainer_1.default;
exports.default = TableContainer_1.default;
//# sourceMappingURL=index.js.map